import React, { FC, useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { AddRoleFormData } from "./validation.schema";
import Select from "@/components/Select/index";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid2";
import { RoleStatusEnum, RoleTypeEnum } from "@/domain/role.enum";

type TabRoleGeneralProps = {
  editMode?: boolean;
};

export const TabRoleGeneral: FC<TabRoleGeneralProps> = ({
  editMode = false,
}) => {
  const { t } = useTranslation("roles");
  const { t: tCommon } = useTranslation("common");

  const statusList = useMemo(() => {
    return Object.values(RoleStatusEnum).map((status) => ({
      key: status,
      value: tCommon(`enums.${status}` as any),
    }));
  }, []);

  const typeList = useMemo(() => {
    return Object.values(RoleTypeEnum).map((type) => ({
      key: type,
      value: t(`enum.${type}` as any),
    }));
  }, [t]);

  const {
    control,
    formState: { errors },
  } = useFormContext<AddRoleFormData>();

  return (
    <Grid container spacing={"20px"}>
      <Grid size={12}>
        <Controller
          name="name"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              id="name"
              label={t("modals.label-name")}
              variant="outlined"
              required
              value={field.value}
              onChange={(value) => field.onChange(value)}
              error={!!errors.name}
              helperText={errors.name ? errors.name.message : null}
              fullWidth
            />
          )}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name="type"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <Select
              handleChange={(value) => {
                field.onChange(value);
              }}
              data={typeList}
              value={field.value as string}
              label={t("modals.label-type")}
              required
              id="type"
              fullWidth
              error={!!errors.type}
              errorMessage={errors.type?.message}
            />
          )}
        />
      </Grid>
      <Grid size={12}>
        <Controller
          name="status"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <Select
              handleChange={(value) => {
                field.onChange(value);
              }}
              data={statusList}
              value={field.value as string}
              label={t("modals.label-status")}
              required
              id="status"
              fullWidth
              error={!!errors.status}
              errorMessage={errors.status?.message}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
